import { CouponInfo } from '../../../../models';

/**
 * Builds the summary's two discount rows. The backend applies promotions per product (summed
 * into `discount`) and the CE coupon at ORDER level: `appliedCoupon.appliedAmount` is already
 * capped at the whole order's post-promotion charge and is never folded into the per-product
 * discountAmounts. The two rows are therefore independent amounts — no double-count subtraction.
 * The Discount row hides itself when a coupon is the only discount (it would read "-$0.00").
 */
export const splitDiscountRows = (
  discount: number,
  appliedCoupon: CouponInfo | undefined,
  showCoupon: boolean,
) => {
  const showCouponLine = showCoupon && !!appliedCoupon;
  const couponDiscount = showCouponLine ? (appliedCoupon?.appliedAmount ?? 0) : 0;
  const promotionDiscount = discount;
  return {
    showCouponLine,
    couponDiscount,
    promotionDiscount,
    showDiscountLine: promotionDiscount > 0 || !showCouponLine,
  };
};
